import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Link, Tooltip, UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { useConnectUser, useHandleConnection, useStreamToken } from '@infl-ts/util-stream-chat-connection';
import MessageIcon from '@mui/icons-material/Message';
import { Badge, IconButton } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { constVoid, flow, pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { StreamChat } from 'stream-chat';
import { STREAM_IO_API_KEY } from '../../../../env';
import { jsx as _jsx } from "react/jsx-runtime";
var chatClient = StreamChat.getInstance(STREAM_IO_API_KEY, {
  timeout: 6000
});
var messageEvents = ['notification.message_new', 'notification.mark_read', 'message.new'];

var useUnreadCount = function useUnreadCount(profile, streamToken) {
  var _useState = useState(0),
      unreadChatCount = _useState[0],
      setUnreadChatCount = _useState[1];

  var wsConnection = chatClient.wsConnection;
  var subscribeToUnreadCount = useCallback(function (event) {
    event.unread_channels !== undefined && setUnreadChatCount(event.unread_channels);
  }, [setUnreadChatCount]);
  var streamConnection = useConnectUser({
    name: profile.name,
    avatarUrl: profile.avatarUrl,
    contactId: profile.id,
    apiKey: STREAM_IO_API_KEY,
    allowConnection: !!streamToken
  });
  var onConnectSuccess = useCallback(function (res) {
    res && res.me && setUnreadChatCount(res.me.unread_channels);
  }, []);
  var onAlreadyConnected = useCallback(function () {
    void pipe(function () {
      return chatClient.recoverState();
    }, T.map(function () {
      (wsConnection === null || wsConnection === void 0 ? void 0 : wsConnection.connectionOpen) && void pipe(wsConnection === null || wsConnection === void 0 ? void 0 : wsConnection.connectionOpen, function (x) {
        return function () {
          return x;
        };
      }, T.map(function (res) {
        res && res.me && setUnreadChatCount(res.me.unread_channels);
      }))();
    }), function (invokeTask) {
      return invokeTask();
    });
  }, [chatClient, wsConnection]);
  useHandleConnection({
    shouldSkip: !DE.isSuccess(streamConnection) || !wsConnection,
    onConnectSuccess: onConnectSuccess,
    onAlreadyConnected: onAlreadyConnected,
    apiKey: STREAM_IO_API_KEY
  });
  useEffect(function () {
    pipe(streamConnection, DE.squash(constVoid, constVoid, function (response) {
      return (response === null || response === void 0 ? void 0 : response.me) && setUnreadChatCount(response.me.unread_channels);
    }));
    var listeners = messageEvents.map(function (event) {
      return chatClient.on(event, subscribeToUnreadCount);
    });
    return function () {
      listeners.map(function (listener) {
        return listener.unsubscribe();
      });
      void DE.isSuccess(streamConnection) && chatClient.closeConnection();
    };
  }, [streamToken, setUnreadChatCount, profile.avatarUrl, profile.name, streamConnection, subscribeToUnreadCount]);
  return unreadChatCount;
};

var Chat = function Chat(_ref) {
  var inChat = _ref.inChat,
      streamToken = _ref.streamToken,
      messagingLink = _ref.messagingLink,
      profile = _ref.profile;
  var unreadChatCount = useUnreadCount(profile, streamToken);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    "data-element": "UnavailableInLens",
    "data-component": "Chat",
    "data-source-file": "chat.tsx",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: t('Messaging'),
      "data-element": "Tooltip",
      "data-component": "Chat",
      "data-source-file": "chat.tsx",
      children: /*#__PURE__*/_jsx(IconButton, {
        component: Link,
        sx: {
          ml: 1
        },
        "aria-label": "messaging",
        disabled: inChat,
        to: inChat ? '#' : messagingLink,
        "data-element": "IconButton",
        "data-component": "Chat",
        "data-source-file": "chat.tsx",
        children: !unreadChatCount ? /*#__PURE__*/_jsx(MessageIcon, {
          color: inChat ? 'primary' : 'inherit'
        }) : /*#__PURE__*/_jsx(Badge, {
          color: "primary",
          badgeContent: unreadChatCount,
          children: /*#__PURE__*/_jsx(MessageIcon, {})
        })
      })
    })
  });
};

var useProps = function useProps(props) {
  var history = useHistory();

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      inChat = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setInChat = _useToggle2$.on,
      setNotInChat = _useToggle2$.off;

  var handleSetInChat = useCallback(function (pathname) {
    pathname.startsWith('/chat') ? setInChat() : setNotInChat();
  }, [setInChat, setNotInChat]);
  useEffect(function () {
    handleSetInChat(history.location.pathname);
    return history.listen(function (location) {
      return handleSetInChat(location.pathname);
    });
  }, [handleSetInChat, history]);
  return pipe(useStreamToken(), DE.squash(function () {
    return _objectSpread(_objectSpread({}, props), {}, {
      inChat: inChat
    });
  }, function () {
    return _objectSpread(_objectSpread({}, props), {}, {
      inChat: inChat
    });
  }, function (streamToken) {
    return _objectSpread(_objectSpread({}, props), {}, {
      inChat: inChat,
      streamToken: streamToken
    });
  }));
};

export default Object.assign(flow(useProps, Chat), {
  displayName: 'Chat'
});